import { HomeView } from './views'
import { reducer } from './store'

export { HomePage } from './views'

export const routes = {
  home: '/',
}

export const routeToInstall = {
  id: 'home',
  path: routes.home,
  exact: true,
  component: HomeView,
}

export const storeToInstall = {
  home: reducer
}
